import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bank-statements"
export default class extends Controller {
  static targets = ["deleteButton"]

  deleteStatement(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const statementId = button.dataset.statementId
    const url = button.dataset.url
    const confirmMessage = button.dataset.confirm
    
    if (confirm(confirmMessage)) {
      // Create a form to submit the DELETE request
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url
      
      // Add the _method hidden field for DELETE
      const methodField = document.createElement('input')
      methodField.type = 'hidden'
      methodField.name = '_method'
      methodField.value = 'DELETE'
      form.appendChild(methodField)
      
      // Add the statement_id field
      const statementField = document.createElement('input')
      statementField.type = 'hidden'
      statementField.name = 'statement_id'
      statementField.value = statementId
      form.appendChild(statementField)
      
      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]')
      if (csrfToken) {
        const csrfField = document.createElement('input')
        csrfField.type = 'hidden'
        csrfField.name = 'authenticity_token'
        csrfField.value = csrfToken.getAttribute('content')
        form.appendChild(csrfField)
      }
      
      // Submit the form
      document.body.appendChild(form)
      form.submit()
    }
  }
}
